module.exports = __webpack_public_path__ + "img/storm.28b3ef28.png";